import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateProjectHeadcountType } from 'spw-redux/modules/projects/actions';
import { RadioGroup, Radio } from '@mui/material';
import { selectLevelHeadcount } from 'spw-redux/modules/program-summary/esa/selectors';
import { formatBigNumber } from 'spw-shared/utils';
import {
  currentProject,
  selectCurrentUserIsViewOnly,
} from 'spw-redux/modules/projects/selectors';
import { HEADCOUNTS, HeadcountType } from 'spw-redux/modules/projects/types';
import { HeadcountFormControlLabel } from 'spw-esa-projects/program-summary/styles';

export const HeadcountOptions = () => {
  const dispatch = useDispatch();
  const levelHeadcount = useSelector(selectLevelHeadcount);
  const project = useSelector(currentProject);
  const currentUserIsViewOnly = useSelector(selectCurrentUserIsViewOnly);

  const saveSelectedHeadcountType = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      dispatch(updateProjectHeadcountType(event.target.value as HeadcountType));
    },
    [dispatch]
  );

  return (
    <RadioGroup
      data-cy="headcount-type"
      aria-label="Headcount"
      name="headcount-options"
      value={project.headcountType}
      onChange={saveSelectedHeadcountType}
      row
    >
      <HeadcountFormControlLabel
        value={HEADCOUNTS.ARCHITECT}
        disabled={currentUserIsViewOnly}
        control={<Radio />}
        className={
          project?.headcountType === HEADCOUNTS.ARCHITECT ? 'selected' : null
        }
        label={
          <div>
            Architect <br />
            Headcount ({formatBigNumber(levelHeadcount.architectHeadcount || 0)}
            )
          </div>
        }
      />
      <HeadcountFormControlLabel
        value={HEADCOUNTS.CLIENT}
        disabled={currentUserIsViewOnly}
        control={<Radio />}
        className={
          project?.headcountType === HEADCOUNTS.CLIENT ? 'selected' : null
        }
        label={
          <div>
            Client <br />
            Headcount ({formatBigNumber(levelHeadcount.clientHeadcount || 0)})
          </div>
        }
      />
    </RadioGroup>
  );
};
